/* eslint-disable no-console */
import assign from 'lodash/assign';
import find from 'lodash/find';

export interface PgExperimentsInterface {
  experimentsList: PgExperimentListItem[];
  list: PgExperimentListItem[];
  activateByIndex: (index: number) => PgExperimentListItem;
  deactivateByIndex: (index: number) => PgExperimentListItem;
  getExperimentByNameAndVariant: (name: string, variant: string) => PgExperimentListItem;
}

interface PgExperimentConstructorItem {
  name: string;
  variant: string;
  active?: boolean;
  key?: string;
}

interface PgExperimentListItem {
  name: string;
  variant: string;
  active: boolean;
  key: string;
  activate: () => void;
  deactivate: () => void;
  isActive: () => boolean;
}

export default class PgExperiments implements PgExperimentsInterface {
  experimentsList: PgExperimentListItem[];

  constructor(experiments: PgExperimentConstructorItem[]) {
    this.experimentsList = experiments.map((exp: PgExperimentConstructorItem, idx: number) => {
      const key = `${exp.name}-${exp.variant}`.replace(/\s/g, '');

      return assign({}, exp, {
        key,
        activate: () => this.activateByIndex(idx),
        deactivate: () => this.deactivateByIndex(idx),
        active: false,
        isActive: () => sessionStorage.getItem(key) === 'true',
      });
    });
  }

  get list() {
    return this.experimentsList;
  }

  activateByIndex = (idx: number) => {
    const experiment = this.experimentsList[idx];

    experiment.active = true;
    sessionStorage.setItem(experiment.key, 'true');
    console.log(experiment.name, experiment.variant, 'activated.');

    return experiment;
  };

  deactivateByIndex = (idx: number) => {
    const experiment = this.experimentsList[idx];

    experiment.active = false;
    sessionStorage.removeItem(experiment.key);
    console.log(experiment.name, experiment.variant, 'deactivated.');

    return experiment;
  };

  getExperimentByNameAndVariant = (name: string, variant: string) =>
    find(this.experimentsList, { name, variant });
}
